
import qs from 'qs';

import { Observable, Subject, from  } from 'rxjs'; 
import { map,mapTo,catchError,debounceTime,distinctUntilChanged } from 'rxjs/operators';

import { PUE_SERVER } from '../server'

import { AuthInfo } from '@/util/user/authInfo';

import { athubAxios, httpUtil } from '@/util'
import { HeaderBuilder } from '@/util/athub-axios/header'   
     
let pueReportUrl       = [ PUE_SERVER , "PUE/daily" ].join("/");
let pueSubsysHourlyUrl = [ PUE_SERVER , "PUE/Subsys/hourly" ].join("/");
let pueHourlyHistoryDataAssetInfoUrl = [ PUE_SERVER , "PUE/hourlyHistory/asset" ].join("/");
let pueAssetHourlyDataUrl = [ PUE_SERVER , "PUE/asset/hourly" ].join("/");


export default class{

    static get( searchParameters ){

        let athubconfig = {
            headers:{
                "User-Auth-Info":encodeURI( JSON.stringify( AuthInfo.details ) )  
            },
            withCredentials:false  
        }; 
        
        let params = httpUtil.removeEmpty( searchParameters );
        params = httpUtil.json2EncodeString( params );
        
        let queryUrl = pueReportUrl + "?queryString=" + params;  
        
        return from( athubAxios.get( queryUrl, athubconfig ) );
    }
    
    static getSubsysHourlyData( searchParameters ){

        let athubconfig = {
            headers:{
                "User-Auth-Info":encodeURI( JSON.stringify( AuthInfo.details ) )  
            },
            withCredentials:false  
        }; 
        
        return from( athubAxios.postByJson( pueSubsysHourlyUrl, searchParameters, athubconfig ) );
    }
    
    static getHourlyHistoryDataAssetInfo( searchParameters ){

        let athubconfig = {
            headers:{
                "User-Auth-Info":encodeURI( JSON.stringify( AuthInfo.details ) )  
            },
            withCredentials:false  
        }; 
        
        return from( athubAxios.postByJson( pueHourlyHistoryDataAssetInfoUrl, searchParameters, athubconfig ) );
    }
    
    static getAssetHourly( searchParameters ){

        let athubconfig = {
            headers:{
                "User-Auth-Info":encodeURI( JSON.stringify( AuthInfo.details ) )  
            },
            withCredentials:false  
        }; 
        
        return from( athubAxios.postByJson( pueAssetHourlyDataUrl, searchParameters, athubconfig ) );
    }
}
